import { render, staticRenderFns } from "./ModuleFunction.vue?vue&type=template&id=f70aadc2&scoped=true&"
import script from "./ModuleFunction.vue?vue&type=script&lang=js&"
export * from "./ModuleFunction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70aadc2",
  null
  
)

export default component.exports